import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Star, ShieldAlert } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import PhoneSearch from "@/components/PhoneSearch";
import TransparencyProfile from "@/components/TransparencyProfile";
import { breadcrumbLd } from "@/lib/siteContent";
import { Button } from "@/components/ui/button";

const crumbs = [{ label: "Home", to: "/" }, { label: "Reviews & Feedback", to: "/reviews" }];

export default function Reviews() {
  const [result, setResult] = useState(null);
  return (
    <div className="ca-container py-12 max-w-4xl">
      <Seo title="Customer and Vendor Reviews & Feedback | ComplaintAdvisor"
        description="Explore available customer and vendor feedback, review responses, complaint status, and moderation information before making business decisions."
        path="/reviews" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3 flex items-center gap-2"><Star className="h-7 w-7 text-teal" /> Reviews & Feedback</h1>
      <p className="text-slate-700 mt-3 leading-relaxed">
        Reviews and feedback can help users understand experiences reported by customers and vendors. Information may be
        positive, negative, incomplete, disputed, or subject to moderation.
      </p>

      <div className="mt-6"><PhoneSearch onResult={setResult} /></div>
      {result && <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 ca-fade-up"><TransparencyProfile profile={result} /></div>}

      <div className="mt-8 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm text-slate-600 flex gap-3">
        <ShieldAlert className="h-5 w-5 text-slate-400 shrink-0 mt-0.5" />
        <div>
          We do not publish private phone numbers, private addresses, identity documents, private messages, or complete
          financial account details. Allegations are not presented as proven facts, and a response or challenge mechanism is provided.
        </div>
      </div>

      <div className="mt-6">
        <p className="text-sm text-slate-600 mb-2">Want to share your experience with a specific business?</p>
        <Link to="/vendors"><Button className="bg-teal-brand hover:bg-teal-700 text-white" data-testid="reviews-submit-cta">Submit Feedback via Vendor Directory</Button></Link>
      </div>
    </div>
  );
}
